module.exports = __webpack_public_path__ + "static/media/cv-pic.e9c4c84e.jpeg";